import type * as React from 'react';

import {
  SkeletonHeadline,
  SkeletonBody,
  SkeletonImage,
  SkeletonButton,
} from '@xing-com/skeleton';

import { StyledCard } from './article-card.styled';

export const ArticleCardSkeleton: React.FC = () => (
  <StyledCard to="#">
    <SkeletonImage height="117px" />
    <SkeletonHeadline size="small" amountRows={2} />
    <SkeletonBody amountRows={4} />
    <SkeletonButton size="small" />
  </StyledCard>
);
